//vista que muestra los asistentes escaneados por un expositor

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
  Box,
  IconButton,
  Grid,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
  CardMedia,
  TablePagination
} from '@mui/material';
import {
  Search,
  GetApp,
  LocationOn,
  CalendarTodayOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
  ExpandMore, ExpandLess,
} from '@mui/icons-material';
/* import { withAuthenticationRequired } from '@auth0/auth0-react'; */
import { useMediaQuery } from "react-responsive";
import { api } from '../../services/api';
import Loading from '../../components/Loading';
import empty from "../../assets/empty.png";
import moment from 'moment';
import withAuthenticationRequired from "../../components/ProtectedRoutes/withAuthenticationRequired";
moment.locale('es');

const Asistentes = () => {
  const { id } = useParams();
  const isMobile = useMediaQuery({ query: `(max-width: 770px)` });

  const [asistentes, setAsistentes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [tempSearchTerm, setTempSearchTerm] = useState('');
  const [evento, setEvento] = useState(null);
  const [expandedId, setExpandedId] = useState(null);

  const [expandedTicket, setExpandedTicket] = useState(null);

  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
    total: 0
  });

  const [stats, setStats] = useState({
    total: 0,
  });

  useEffect(() => {
    fetchasistentes();
    fetchEvento();
  }, [id, pagination.current, pagination.pageSize, searchTerm]);

  const fetchEvento = async () => {
    try {
      const response = await api.eventos.get(id);
      if (response.status === 'success') {
        setEvento(response.data.evento);
      }
    } catch (error) {
      console.error('Error fetching evento:', error);
    }
  };

  const fetchasistentes = async () => {
    try {
      setLoading(true);

      const response = await api.expositores.getAllAsistentes(id);

      if (response.status === 'success') {
        const allasistentes = response.data;

        const filteredData = allasistentes.filter(asistente => {
          if (!searchTerm) return true;
          const searchLower = searchTerm.toLowerCase();
          return (
            asistente.ticket?.nombre?.toLowerCase().includes(searchLower) ||
            asistente.ticket?.apellido?.toLowerCase().includes(searchLower) ||
            asistente.ticket?.tarifa?.concepto?.toLowerCase().includes(searchLower)
          );
        });

        const startIndex = pagination.current * pagination.pageSize;
        const endIndex = startIndex + pagination.pageSize;
        const paginatedData = filteredData.slice(startIndex, endIndex);

        setAsistentes(paginatedData);
        setPagination(prev => ({ ...prev, total: filteredData.length }));

        const total = allasistentes.length;


        setStats({ total});
      }
    } catch (error) {
      console.error('Error fetching asistentes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setTempSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      executeSearch();
    }
  };

  const executeSearch = () => {
    setSearchTerm(tempSearchTerm);
    setPagination(prev => ({ ...prev, current: 0 }));
  };

  const handleChangePage = (event, newPage) => {
    setPagination(prev => ({ ...prev, current: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPagination(prev => ({
      ...prev,
      pageSize: newSize,
      current: 0,
    }));
  };

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const formatDate = (dateString) => {
    return moment(dateString).format("DD/MM/YYYY HH:mm");
  };

  const downloadExcel = async () => {
    try {
      const blob = await api.expositores.downloadAsistentesExcel(id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `asistentes_${evento?.evento || 'evento'}.xlsx`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar archivo:', error);
    }
  };

  if (loading && asistentes.length === 0) {
    return <Loading />;
  }

  return (
    <div className="container-fluid" style={{ padding: "10px 4%" }}>
      <div className="row mb-4 align-items-center">
        <div className="col-md-8">
          <TextField
            placeholder='Buscar asistente por nombre, apellido o tarifa...'
            variant='outlined'
            value={tempSearchTerm}
            onChange={handleSearchChange}
            onKeyDown={handleKeyDown}
            sx={{
              maxWidth: '600px',
              width: '100%',
              '& .MuiOutlinedInput-root': {
                height: '40px !important',
                '& fieldset': {
                  borderColor: '#B5BABF',
                },
                '&:hover fieldset': {
                  borderColor: '#0B0060',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#0B0060',
                },
              },
            }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton size='small' onClick={executeSearch} sx={{ marginLeft: "-8px" }}>
                      <Search sx={{ color: '#6B7280' }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            }}
          />
        </div>

        <div className={`col-md-4 ${isMobile ? 'mt-3' : 'text-end'}`}>
          <Button
            variant="outlined"
            startIcon={<GetApp />}
            onClick={downloadExcel}
            disabled={stats.total === 0}
            sx={{
              fontFamily: 'Bricolage Grotesque',
              width: isMobile ? '100%' : 'auto',
              borderColor: '#8E8EFF',
              color: '#5656FF',
              '&:hover': {
                borderColor: '#5656FF',
                backgroundColor: '#F5F5FF'
              }
            }}
          >
            Exportar
          </Button>
        </div>
      </div>

      <div>
        {stats.total > 0 ? (
          <>
            {isMobile ? (
              <>
                <div className="mt-3">
                  {loading ? (
                    <div className="d-flex justify-content-center my-4">
                      <CircularProgress />
                    </div>
                  ) : (
                    asistentes.map((asistente) => (
                      <div
                        key={asistente.id}
                        className="card mb-3"
                        style={{ borderRadius: '8px', border: '1px solid #E0E0E0' }}
                      >
                        <div
                          className="card-body p-3"
                          onClick={() => toggleExpand(asistente.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="d-flex position-relative align-items-center" style={{ width: '100%' }}>
                            <div style={{ marginRight: '10px', flexShrink: 0 }}>
                              {expandedId === asistente.id ?
                                <KeyboardArrowUp sx={{ color: "#5656ff" }} />
                                :
                                <KeyboardArrowDown sx={{ color: "#5656ff" }} />
                              }
                            </div>
                            <div style={{
                              maxWidth: 'calc(100% - 95px)',
                              color: "#0b0060",
                              fontFamily: "Bricolage Grotesque",
                              fontWeight: 500,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              paddingRight: "10px"
                            }}>
                              {asistente.ticket?.nombre} {asistente.ticket?.apellido}
                            </div>

                            <div style={{
                              position: 'absolute',
                              right: 0,
                              fontWeight: '500',
                              color: "black",
                              fontFamily: "Bricolage Grotesque",
                              minWidth: "80px",
                              textAlign: 'right',
                            }}>
                              ${asistente.ticket?.tarifa?.precio?.toLocaleString('es-AR')}
                            </div>
                          </div>

                          {expandedId === asistente.id && (
                            <div className="mt-3 pt-3" style={{ borderTop: '1px solid #E6E6FF' }}>
                              <div className="row g-3">
                                <div className="col-12">
                                  <div className="d-flex align-items-center flex-row justify-content-between">
                                    <span>Tarifa:</span>
                                    <div style={{
                                      backgroundColor: '#E6E6FF',
                                      color: '#5656FF',
                                      padding: '4px 8px',
                                      borderRadius: '12px',
                                      fontSize: '12px',
                                      fontFamily: 'Bricolage Grotesque'
                                    }}>
                                      {asistente.ticket?.tarifa?.concepto}
                                    </div>
                                  </div>
                                </div>
                                {asistente.ticket?.tarifa?.ubicacion && (
                                  <div className="col-12">
                                    <div className="d-flex justify-content-between align-items-center flex-row">
                                      <span>Ubicación:</span>
                                      <div className="d-flex align-items-center">
                                        <LocationOn sx={{ fontSize: '16px', color: '#6B7280', marginRight: '4px' }} />
                                        <span style={{ fontSize: '14px', color: '#6B7280', fontFamily: 'Bricolage Grotesque' }}>
                                          {asistente.ticket.tarifa.ubicacion.ubicacion}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="col-12">
                                  <div className="d-flex justify-content-between align-items-center flex-row">
                                    <span>Fecha escaneado:</span>
                                    <div>
                                      <CalendarTodayOutlined sx={{ width: "16px", height: "16px", color: "#5656FF", marginRight: "8px" }} />
                                      <span style={{ fontSize: '14px', color: '#525252', fontFamily: "Bricolage Grotesque" }}>
                                        {formatDate(asistente.registrado)}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-12 mt-2">
                                  <div style={{
                                    backgroundColor: '#F5F5FF',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    border: '1px solid #E6E6FF'
                                  }}>
                                    <p style={{
                                      fontSize: '14px',
                                      fontWeight: '600',
                                      color: '#5656FF',
                                      marginBottom: '8px',
                                      fontFamily: 'Bricolage Grotesque'
                                    }}>
                                      Información Adicional
                                    </p>
                                    {asistente.ticket?.informacion_adicional?.length > 0 ? (
                                      asistente.ticket.informacion_adicional.map((info, index) => (
                                        <div key={index} style={{ marginBottom: '8px' }}>
                                          <span style={{
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#0B0060',
                                            fontFamily: 'Bricolage Grotesque'
                                          }}>
                                            {info.informacion_adicional?.informacion_adicional}:
                                          </span>{' '}
                                          <span style={{
                                            fontSize: '12px',
                                            color: '#525252',
                                            fontFamily: 'Bricolage Grotesque'
                                          }}>
                                            {info.respuesta || 'Sin respuesta'}
                                          </span>
                                        </div>
                                      ))
                                    ) : (
                                      <div style={{
                                        fontSize: '12px',
                                        color: '#6B7280',
                                        fontFamily: 'Bricolage Grotesque',
                                        fontStyle: 'italic',
                                        textAlign: 'center',
                                        padding: '8px'
                                      }}>
                                        No hay información adicional disponible
                                      </div>
                                    )}
                                  </div>
                                </div>

                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ))
                  )}

                  <div className="d-flex justify-content-between align-items-center my-3">
                    <div className="d-flex align-items-center">
                      <select
                        className="form-select form-select-sm"
                        style={{
                          width: 'auto',
                          marginRight: '8px',
                          borderColor: '#E6E6FF',
                          color: '#0B0060',
                          fontSize: '14px',
                          fontFamily: 'Bricolage Grotesque'
                        }}
                        value={pagination.pageSize}
                        onChange={handleChangeRowsPerPage}
                      >
                        {[10, 25, 50].map(size => (
                          <option key={size} value={size}>{size}</option>
                        ))}
                      </select>
                    </div>

                    <div className="d-flex align-items-center">
                      <IconButton
                        onClick={(e) => handleChangePage(e, 0)}
                        disabled={pagination.current === 0}
                        size="small"
                        sx={{
                          padding: '4px',
                          color: pagination.current === 0 ? '#B5BABF' : '#0B0060',
                          '&:hover': { backgroundColor: '#F5F5FF' }
                        }}
                      >
                        <FirstPage fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={(e) => handleChangePage(e, pagination.current - 1)}
                        disabled={pagination.current === 0}
                        size="small"
                        sx={{
                          padding: '4px',
                          color: pagination.current === 0 ? '#B5BABF' : '#0B0060',
                          '&:hover': { backgroundColor: '#F5F5FF' }
                        }}
                      >
                        <ChevronLeft fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={(e) => handleChangePage(e, pagination.current + 1)}
                        disabled={pagination.current >= Math.ceil(pagination.total / pagination.pageSize) - 1}
                        size="small"
                        sx={{
                          padding: '4px',
                          color: pagination.current >= Math.ceil(pagination.total / pagination.pageSize) - 1 ? '#B5BABF' : '#0B0060',
                          '&:hover': { backgroundColor: '#F5F5FF' }
                        }}
                      >
                        <ChevronRight fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={(e) => handleChangePage(e, Math.max(0, Math.ceil(pagination.total / pagination.pageSize) - 1))}
                        disabled={pagination.current >= Math.ceil(pagination.total / pagination.pageSize) - 1}
                        size="small"
                        sx={{
                          padding: '4px',
                          color: pagination.current >= Math.ceil(pagination.total / pagination.pageSize) - 1 ? '#B5BABF' : '#0B0060',
                          '&:hover': { backgroundColor: '#F5F5FF' }
                        }}
                      >
                        <LastPage fontSize="small" />
                      </IconButton>
                    </div>

                    <div className="d-flex align-items-center">
                      <span style={{
                        fontSize: '14px',
                        marginLeft: '12px',
                        color: '#71717A',
                        fontFamily: 'Bricolage Grotesque'
                      }}>
                        {pagination.total > 0 ? `${pagination.current * pagination.pageSize + 1}-${Math.min((pagination.current + 1) * pagination.pageSize, pagination.total)} de ${pagination.total}` : '0-0 de 0'}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* DESKTOP*/}
                <TableContainer component={Paper} className="mt-3">
                  <Table aria-label="asistentes table">
                    <TableHead sx={{ backgroundColor: "#E6E6FF" }}>
                      <TableRow sx={{ borderColor: "#E6E6FF" }}>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }}>
                          Asistente
                        </TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">
                          Tarifa
                        </TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">
                          Ubicación
                        </TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">
                          Precio
                        </TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">
                          Fecha Escaneado
                        </TableCell>
                        <TableCell sx={{ fontSize: "16px", fontWeight: "600", color: "#0B0060", fontFamily: "Bricolage Grotesque" }} align="center">
                          Detalles
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center">
                            <CircularProgress />
                          </TableCell>
                        </TableRow>
                      ) : (
                        asistentes.map((asistente) => (
                          <React.Fragment key={asistente.id}>
                            <TableRow
                              sx={{
                                '&:hover': { backgroundColor: '#F8F9FA' },
                                cursor: 'pointer'
                              }}
                            >
                              <TableCell sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0060" }}>
                                <div className="d-flex align-items-center">
                                  <div style={{
                                    backgroundColor: '#5656FF',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '12px',
                                    color: 'white',
                                    fontWeight: '600',
                                    fontSize: '14px'
                                  }}>
                                    {asistente.ticket?.nombre?.[0]}{asistente.ticket?.apellido?.[0]}
                                  </div>
                                  <div>
                                    <div style={{ fontWeight: '500', fontSize: '16px' }}>
                                      {asistente.ticket?.nombre} {asistente.ticket?.apellido}
                                    </div>
                                    <div style={{ fontSize: '14px', color: '#6B7280' }}>
                                      Ticket #{asistente.ticket?.id}
                                    </div>
                                  </div>
                                </div>
                              </TableCell>

                              <TableCell align="center">
                                <Chip
                                  size="small"
                                  label={asistente.ticket?.tarifa?.concepto}
                                  sx={{
                                    backgroundColor: '#E6E6FF',
                                    color: '#5656FF',
                                    fontFamily: 'Bricolage Grotesque'
                                  }}
                                />
                              </TableCell>

                              <TableCell sx={{ fontFamily: "Bricolage Grotesque" }} align="center">
                                <div className="d-flex justify-content-center align-items-center">
                                  <LocationOn sx={{ fontSize: '16px', color: '#6B7280', marginRight: '4px' }} />
                                  <span style={{ color: '#6B7280' }}>
                                    {asistente.ticket?.tarifa?.ubicacion?.ubicacion || 'Sin ubicación'}
                                  </span>
                                </div>
                              </TableCell>

                              <TableCell align="center" sx={{ fontFamily: "Bricolage Grotesque" }}>
                                <div className="d-flex justify-content-center align-items-center">
                                  <span style={{ fontWeight: '500', color: 'black' }}>
                                    ${asistente.ticket?.tarifa?.precio?.toLocaleString('es-AR')}
                                  </span>
                                </div>
                              </TableCell>

                              <TableCell sx={{ fontFamily: "Bricolage Grotesque" }} align="center">
                                <div className="d-flex justify-content-center align-items-center">
                                  <CalendarTodayOutlined sx={{ fontSize: '16px', color: '#5656FF', marginRight: '8px' }} />
                                  {formatDate(asistente.registrado)}
                                </div>
                              </TableCell>

                              <TableCell align="center">

                                <IconButton
                                  size="small"
                                  onClick={() => setExpandedTicket(expandedTicket === asistente.id ? null : asistente.id)}
                                  sx={{ color: '#5656FF' }}
                                >
                                  {expandedTicket === asistente.id ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>

                              </TableCell>
                            </TableRow>
                            {expandedTicket === asistente.id && (
                              <TableRow>
                                <TableCell colSpan={6} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                  <Box sx={{ margin: 1 }}>
                                    <Typography variant="h6" gutterBottom sx={{
                                      color: '#5656FF',
                                      fontFamily: 'Bricolage Grotesque',
                                      fontSize: '16px',
                                      fontWeight: 600
                                    }}>
                                      Información Adicional
                                    </Typography>
                                    <Grid container spacing={2}>
                                      {asistente.ticket?.informacion_adicional?.length > 0 ? (
                                        <Grid container spacing={2}>
                                          {asistente.ticket.informacion_adicional.map((info, index) => (
                                            <Grid item xs={12} md={6} key={index}>
                                              <Box sx={{
                                                padding: 2,
                                                borderRadius: 1,
                                              }}>
                                                <Typography variant="body2" sx={{
                                                  fontWeight: 600,
                                                  color: '#0B0060',
                                                  fontFamily: 'Bricolage Grotesque',
                                                  marginBottom: 0.5
                                                }}>
                                                  {info.informacion_adicional?.informacion_adicional || 'Pregunta'}
                                                </Typography>
                                                <Typography variant="body2" sx={{
                                                  color: '#525252',
                                                  fontFamily: 'Bricolage Grotesque'
                                                }}>
                                                  {info.respuesta || 'Sin respuesta'}
                                                </Typography>
                                              </Box>
                                            </Grid>
                                          ))}
                                        </Grid>
                                      ) : (
                                        <Box sx={{
                                          padding: 3,
                                          borderRadius: 1,
                                          textAlign: 'center'
                                        }}>
                                          <Typography variant="body2" sx={{
                                            color: '#6B7280',
                                            fontFamily: 'Bricolage Grotesque',
                                            fontStyle: 'italic'
                                          }}>
                                            No hay información adicional disponible para este ticket
                                          </Typography>
                                        </Box>
                                      )}
                                    </Grid>
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )}
                          </React.Fragment>
                        ))
                      )}
                    </TableBody>
                  </Table>

                  <TablePagination
                    component="div"
                    className="d-flex justify-content-center"
                    rowsPerPageOptions={[10, 25, 50]}
                    count={pagination.total}
                    rowsPerPage={pagination.pageSize}
                    page={pagination.current}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage="Registros p/página"
                    showFirstButton
                    showLastButton
                  />
                </TableContainer>
              </>
            )}
          </>
        ) : (
          <>
            <div className="d-flex flex-column align-items-center">
              <CardMedia
                component="img"
                sx={{ width: 200 }}
                image={empty}
                alt="Empty"
              />
              <small className="text-secondary">
                {searchTerm ? 'No se encontraron asistentes con esos criterios.' : 'Aún no hay asistentes escaneados.'}
              </small>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default withAuthenticationRequired(Asistentes, {
  onRedirecting: () => <Loading />
});